import { z } from "zod";

export const HttpMethodSchema = z.enum([
  "GET",
  "POST",
  "PUT",
  "PATCH",
  "DELETE",
  "HEAD",
  "OPTIONS"
]);
export type HttpMethod = z.infer<typeof HttpMethodSchema>;

export const ParamLocationSchema = z.enum(["path", "query", "header", "cookie", "body"]);
export type ParamLocation = z.infer<typeof ParamLocationSchema>;

/**
 * OAuth-style scope name: lowercase, dotted/colon-separated. Example: "pets.read", "orders:charge".
 * Matches the convention RFC 6749 leaves open; we constrain to avoid surprises in downstream parsers.
 */
export const ScopeSchema = z
  .string()
  .regex(/^[a-z][a-z0-9_:.-]*$/, "scope must be lowercase + [a-z0-9_:.-]");
export type Scope = z.infer<typeof ScopeSchema>;

/** A sha256 hex digest (lowercase, 64 chars). */
export const Sha256HexSchema = z.string().regex(/^[a-f0-9]{64}$/, "expected sha256 hex");
export type Sha256Hex = z.infer<typeof Sha256HexSchema>;

/** A JSON Schema fragment we accept opaquely (the OpenAPI spec carries it). */
export const JsonSchemaFragmentSchema = z.unknown();
export type JsonSchemaFragment = unknown;
